import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import FormikControl from "../../formikcontrols";
import "./VendorModal.scss";
import { privateRequest } from "../../../api/apiConfig/privateRequest";
import {
  designationOptionsUtility,
  rolesOptionsUtility,
} from "../../../customHooks";
import { emailRegex, phoneRegExp } from "../../../utils/validation";

const VendorMasterModal = ({
  isOpen,
  closeModal,
  title,
  data,
  addData,
  updateData,
}) => {
  const [error, setError] = useState("");
  const initialValues = {
    organization: "",
    name: "",
    email: "",
    mobile: "",
  };
  var validationSchema = Yup.object().shape({
    email: Yup.string()
      .matches(emailRegex, "You have entered an invalid email address!")
      .required("Email id required"),
    mobile: Yup.string()
      .matches(phoneRegExp, "Phone number is not valid")
      .max(10, "contact number should be 10 digit"),
    organization: Yup.string().required("Organization name is not required"),
    name: Yup.string().required("Name is not required"),
  });
  const handleSubmit = async (values) => {
    if (data === undefined) {
      addData({ ...values });
      closeModal();
    } else {
      if (data == values) {
        setError("Please Change The Value");
      } else {
        updateData({ ...values });
        closeModal();
      }
    }
  };
  const handleChange = (value) => {};

  useEffect(() => {}, []);
  return (
    <div className="vendor_modal">
      <Modal
        show={isOpen}
        onHide={isOpen}
        dialogClassName="vendorModal"
        contentClassName="vendorContent"
        backdropClassName="vendorBackdrop"
        centered
        size="lg"
      >
        <Modal.Header>
          <span className="vendor_modal__sec--head">
            {data === undefined ? "Add" : "Edit"} {title}
          </span>
        </Modal.Header>
        <Modal.Body style={{ overflow: "scroll", height: 400 }}>
          <Formik
            initialValues={data === undefined ? initialValues : data}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {(formik) => {
              return (
                <>
                  <Form className="vendor_modal__sec--body-form">
                    <FormikControl
                      control="input"
                      label="Organization Name"
                      name="organization"
                      required={true}
                    />
                    <FormikControl
                      control="input"
                      label="Name"
                      name="name"
                      required={true}
                    />
                    <FormikControl
                      control="input"
                      label="Email id"
                      name="email"
                      required={true}
                    />
                    <FormikControl
                      control="input"
                      label="Contact Number"
                      name="mobile"
                    />

                    <Modal.Footer className="vendor_modal__sec--body-form-bottom">
                      <Button className="vendor_modal__sec--btn" type="submit">
                        {data === undefined ? "Add" : "Update"}
                      </Button>
                      <Button
                        className="vendor_modal__sec--btn modal__sec--btn-close"
                        onClick={closeModal}
                      >
                        Close
                      </Button>
                    </Modal.Footer>
                  </Form>
                  <div className="errormsg">{error}</div>
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VendorMasterModal;
